module.exports = __webpack_public_path__ + "static/media/ic_chevron_right_24px.14468bc8.svg";